import {
  differenceInCalendarYears,
  differenceInCalendarMonths,
  differenceInCalendarDays,
  addYears,
  addMonths,
  getMonth,
  getYear,
} from 'date-fns-jalali';

// تعیین تعداد روزهای هر ماه شمسی
function getDaysInJalaliMonth(year: number, month: number): number {
  if (month < 6) return 31; // فروردین تا شهریور
  if (month < 11) return 30; // مهر تا بهمن
  const isLeapYear = (year + 2346) % 4 === 0; // بررسی سال کبیسه
  return isLeapYear ? 30 : 29; // اسفند
}

export default function CalculateDuration(
  translate: (key: string) => string,
  discountStartDate?: Date,
  discountEndDate?: Date,
  ResponseLocal?: boolean
) {
  const startDate = discountStartDate ? new Date(discountStartDate) : new Date();
  const endDate = discountEndDate ? new Date(discountEndDate) : new Date();

  if (startDate > endDate) {
    return '';
  }

  let years = differenceInCalendarYears(endDate, startDate);
  let tempDate = addYears(startDate, years);

  // اگر تاریخ موقت از تاریخ پایان بزرگ‌تر شد، یک سال کم کن
  if (tempDate > endDate) {
    years--;
    tempDate = addYears(startDate, years);
  }

  let months = differenceInCalendarMonths(endDate, tempDate);
  tempDate = addMonths(tempDate, months);

  // اگر تاریخ موقت از تاریخ پایان بزرگ‌تر شد، یک ماه کم کن
  if (tempDate > endDate) {
    months--;
    tempDate = addMonths(tempDate, -1);
  }

  let days = differenceInCalendarDays(endDate, tempDate) + 1;

  // بررسی اگر روزها معادل طول ماه باشد
  const currentMonthDays = getDaysInJalaliMonth(getYear(tempDate), getMonth(tempDate));
  if (days >= currentMonthDays) {
    months++;
    days = 0;
  }

  // اصلاح مقادیر منفی ماه
  if (months < 0) {
    years--;
    months += 12;
  }

  if (months === 12) {
    years++;
    months = 0;
  }
  const yearlocal = ResponseLocal ? 'سال' : translate('RentPayment.Year');
  const monthlocal = ResponseLocal ? 'ماه' : translate('RentPayment.Month');
  const daylocal = ResponseLocal ? 'روز' : translate('RentPayment.Day');

  const parts = [];
  if (years > 0) parts.push(`${years}  ${yearlocal}`);
  if (months > 0) parts.push(`${months} ${monthlocal}`);
  if (days > 0) parts.push(`${days} ${daylocal}`);

  return parts.length > 0 ? parts.join(', ') : '';
  // return `${years} ${translate('RentPayment.Year')}, ${months} ${translate('RentPayment.Month')}, ${days} ${translate('RentPayment.Day')}`;
}
